import Templates from "components/pdf-template";


function PrintTemplate() {
  return (
    <div className="content">
      <div className="flex justify-between items-center flex-wrap">
        <h1> قالب پرینت</h1>

  
      </div>
      <Templates
        //   setSelectedTemplate={setSelectedTemplate}
        //   selectedTemplate={selectedTemplate}

        />
    </div>
  );
}

export default PrintTemplate;
